import React from 'react';

import { useSelector } from 'react-redux';
import { okrsPageSelector } from 'selectors/okrsPage';

import { ClickThroughIndividualAgGridTable } from './ClickThroughIndividualAgGridTable';

const ClickThroughIndividualTable = () => {
  const {
    insights: { clickThroughViewData },
  } = useSelector(okrsPageSelector);

  return <ClickThroughIndividualAgGridTable employeeId={clickThroughViewData?.parentUuid} />;
};

export default ClickThroughIndividualTable;
